<template>
  <li class="bg-white p-2">
    <router-link :to="{name: 'musique-lyrics-page', params: {id: musique?.id}}" class="">
      <div class="media media-45 rounded-circle">
        <img src="../assets/pngeg.png" alt="image">
      </div>
      <div class="media-content">
        <div>
          <h6 class="text-start name">{{musique?.title}}</h6>
          <p class="my-1 text-start">
            {{musique?.author}}
          </p>
        </div>
        <span class="time"></span>
      </div>
    </router-link>
  </li>
</template>

<script setup>

import {onMounted} from "vue";

// eslint-disable-next-line no-undef
defineProps({
  musique: {
    type: Object,
  },
  id: {
    type: String,
    default: "1"
  }
})

onMounted(() => {
})

</script>

<style scoped>
.rounded-circle{

}
</style>